import { ReactElement, Suspense, lazy } from 'react';
import useIsMobile from '../../../hooks/use-is-mobile';
import withErrorBoundaryWrapper from '../../../ui/error-boundary/with-error-boundary-wrapper';
import MaterialLongTemplate from './template/material-long-template';

const BottomPartMobile = lazy(() => import('./mobile-parts/bottom-part/bottom-part'));
const BottomPartDesktop = lazy(() => import('./desktop-parts/bottom-part/bottom-part'));
const RightPartDesktop = lazy(() => import('./desktop-parts/right-part/right-part'));

// AB TEST - SRCH-1364 (remove on either accept or reject)
type MaterialLongProps = MaterialBlock & {
    addToCartButtonClassNames?: string;
    classesComponent?: ReactElement;
    highlightEnabled?: boolean;
};

const MaterialLong = (props: MaterialLongProps) => {
    const mobile = useIsMobile();

    const bottomBlock = mobile ? (
        <Suspense>
            <BottomPartMobile {...props} />
        </Suspense>
    ) : (
        <Suspense>
            <BottomPartDesktop {...props} />
        </Suspense>
    );

    const rightBlock = mobile ? null : (
        <Suspense>
            {/* @ts-ignore */}
            <RightPartDesktop {...props} />
        </Suspense>
    );

    return <MaterialLongTemplate {...props} bottomBlock={bottomBlock} rightBlock={rightBlock} />;
};

export default withErrorBoundaryWrapper(MaterialLong);
